import React, { Component } from 'react';
import axios from 'axios';
import update from 'immutability-helper';
import { Configurations } from '../../Utils/Configurations';
import './Logistics.scss';
import ShippingSummary from '../../Components/Shipping-Summary/ShippingSummary';
import ShippingItemsToAdd from '../../Components/ShippingItemsToAdd/ShippingItemsToAdd';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';


class NewShipping extends Component {

    constructor() {
        super();

        this.newShipping = this.newShipping.bind(this);
        this.onEditionChange = this.onEditionChange.bind(this);
        this.onProductChange = this.onProductChange.bind(this);
        this.onShippingCompChange = this.onShippingCompChange.bind(this);
        this.getDeliveryPlaces = this.getDeliveryPlaces.bind(this);
        this.addToDeliveryPlaces = this.addToDeliveryPlaces.bind(this);
        this.getShippingById = this.getShippingById.bind(this);
        this.addToShipping = this.addToShipping.bind(this);
        this.toggleModalItemsAddNewShipping = this.toggleModalItemsAddNewShipping.bind(this);
        this.setarFlagReenvio = this.setarFlagReenvio.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            shippingList: [],
            isLoadingNewShipping: false,
            isLoadingShippingSummary: false,
            isLoadingAddingItems: false,
            // shipping: {
            //     id: 15,
            //     items: 0,
            //     products: [],
            //     editions: []
            // },
            shipping: undefined,
            resetProducts: false,
            deliveryPlaces: [],
            availableDeliveryPlaces: [],
            allDeliveryPlaces: true,
            hasError: false,
            errorMessage: '',
            // isOpenModalItemsAddNewShipping: false.valueOf,
            isOpenModalItemsAddNewShipping: false,
            flagReenvio: false
        };

    }

    async newShipping(reenvio) {
        this.setState({ isLoadingNewShipping: true })
        const _newShipping = axios.post(this.Configurations.apiBasePath + `/logistica/remessa/nova`);

        _newShipping.then(response => {
            this.setState({
                flagReenvio: reenvio,
                shipping: {
                    id: response.data.remessa.id,
                    items: 0,
                    products: [],
                    editions: []
                }
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingNewShipping: false }))
    }


    async getShippingById() {
        this.setState({ isLoadingShippingSummary: true })
        const _productsList = axios.get(this.Configurations.apiBasePath + `/logistica/remessas/${this.state.shipping.id}`);

        _productsList.then(response => {
            const _shipping = response.data.remessa;

            this.setState({
                shipping: {
                    id: this.state.shipping.id,
                    items: _shipping.totalItens,
                    products: _shipping.produtos,
                    editions: _shipping.edicoes,
                    deliveryPlaces: _shipping.locaisEntrega,
                    individualDeliveries: _shipping.entregasIndividuais
                },
                resetProducts: false
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingShippingSummary: false }))
    }

    async getDeliveryPlaces() {
        this.setState({ isLoadingDeliveryPlaces: true })
        const _deliveryPlacesList = axios.get(this.Configurations.apiBasePath + `/logistica/locais-entrega?qtdItens=1500`);

        _deliveryPlacesList.then(response => {
            this.setState({
                availableDeliveryPlaces: response.data.locaisEntrega
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingDeliveryPlaces: false }))
    }


    onProductChange(e) {
        this.setState({
            selectedProduct: e.selectedProduct
        })
    }

    onShippingCompChange(e) {
        this.setState({
            selectedShippingComp: e.selectedShippingComp
        })
    }

    onEditionChange(e) {
        this.setState({
            selectedEdition: e.selectedEdition
        })
    }

    addToDeliveryPlaces() {
        const _newAvailableDeliveryPlaces = update(this.state.deliveryPlaces, { $push: this.state.selectedDeliveryPlaces });

        this.setState({
            deliveryPlaces: _newAvailableDeliveryPlaces,
            selectedDeliveryPlaces: undefined
        }, () => {
            this.typeahead.getInstance().clear()
        });
    }

    addToShipping() {
        this.setState({ isLoadingAddingItems: true })
        const _itemsToShipping = axios.post(this.Configurations.apiBasePath + `/logistica/remessa/adicionar-itens`, {
            idProduto: this.state.selectedProduct,
            idTransportadora: this.state.selectedShippingComp,
            numEdicao: this.state.selectedEdition,
            idRemessa: this.state.shipping.id
        });


        _itemsToShipping.then(response => {
            this.setState({
                resetProducts: true
            }, () => {
                this.getShippingById();
                this.toggleModalItemsAddNewShipping()
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingAddingItems: false }))
    }

    toggleModalItemsAddNewShipping() {
        this.setState({ isOpenModalItemsAddNewShipping: !this.state.isOpenModalItemsAddNewShipping })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    setarFlagReenvio(value) {
        this.setState({ flagReenvio: value })
    }

    render() {
        return (
            <div className="shipping-list logistics">
                <div className="row">
                    {this.state.flagReenvio ? (
                        <div className="col-8">
                            <h2 className="title-1">Remessa Reenvio</h2>
                        </div>
                    ) : (
                        <div className="col-8">
                            <h2 className="title-1">Nova Remessa</h2>
                        </div>
                    )}
                    {(this.state.shipping || this.state.flagReenvio) && (
                        <div className="col-4 text-right">
                            <button className="btn btn-outline-secondary" onClick={() => { this.props.history.push('/logistica/remessas/nova') }}>Voltar</button>
                        </div>
                    )}
                </div>
                {!this.state.flagReenvio && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <ShippingSummary
                                shipping={this.state.shipping}
                                isLoading={this.state.isLoadingShippingSummary}
                                newShippingEvent={this.newShipping}
                                idRemessa={!!this.state.shipping ? this.state.shipping.id : null}
                                setarFlagReenvio={this.setarFlagReenvio}
                                flagReenvio={this.state.flagReenvio}
                            />
                        </div>
                    </div>
                )}
                {(!!this.state.shipping || this.state.flagReenvio) && (
                    <ShippingItemsToAdd
                        shipping={this.state.shipping}
                        resetProducts={this.state.resetProducts}
                        onProductChange={this.onProductChange}
                        onShippingCompChange={this.onShippingCompChange}
                        onEditionChange={this.onEditionChange}
                        addToShippingEvent={this.addToShipping}
                        isLoadingAddingItems={this.state.isLoadingAddingItems}
                        flagReenvio={this.state.flagReenvio}
                    />
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
                <Modal isOpen={this.state.isOpenModalItemsAddNewShipping} toggle={this.toggleModalItemsAddNewShipping}>
                    <ModalBody>
                        <p className='m-0'>Itens adicionados com sucesso!</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggleModalItemsAddNewShipping} color="primary"> ok</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default NewShipping;
